import { KYC_LEVELS } from "@constants/kyc"
import { WHITE } from "@styles/colors"
import { INTER } from "@styles/fonts"

const KYCLevelNumber = ({
    number,
    size = 32
}: {
    number: number
    size?: number
}) => {
    return (
        <div
            style={{
                backgroundColor: KYC_LEVELS[number].primaryColor,
                borderRadius: '100%',
                color: WHITE,
                aspectRatio: 1,
                width: size,
                height: size,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: INTER.semiBold,
            }}
        >
            <span>{number}</span>
        </div>
    )
}

export default KYCLevelNumber